<template>
  <div>
    <div class="page-header bordered">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <h1>
            My Events
          </h1>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <select name="event_list" v-model="eventStatus" @change="loadEvents"
            class="form-control form-control-lg ui-select col-lg-5 float-right">
            <option value="published"> Published </option>
            <option value="past"> Past </option>
          </select>
        </div>
      </div>
    </div>

    <div class="item-listing list">
      <div class="item" v-for="(event) in events" :key="event.id">
        <div class="row">
          <div class="col-lg-5">
            <div v-if="event.image_url" class="item-image">
              <img :src="event.image_url" class="img-fluid">
            </div>

            <div v-else class="text-center">
              <i class="fa fa-picture-o" style="font-size: 10em;" aria-hidden="true"></i>
            </div>

            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <b-button size="sm" variant="outline-default" v-on:click="showEvent(event.id)">
                  <i class="fa fa-eye"></i> Details
                </b-button>
              </div>
              <div v-if="$localStorage.get('user_type').match(/admin|client_admin/)"
                class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <b-button size="sm" variant="outline-default" v-on:click="editEvent(event.id)">
                  <i class="fa fa-pencil-square-o"></i> Edit
                </b-button>
              </div>
              <div v-if="$localStorage.get('user_type').match(/admin|client_admin/)"
                class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <b-button size="sm" variant="outline-default" v-on:click="deleteEvent(event.id)">
                  <i class="fa fa-trash-o"></i> Delete
                </b-button>
              </div>
              <div v-if="$localStorage.get('user_type').match(/admin|client_admin/)"
                class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <b-button size="sm" variant="outline-default" v-on:click="duplicateEvent(event)">
                  <i class="fa fa-clone"></i> Clone
                </b-button>
              </div>
            </div>
          </div>

          <div class="col-lg-7">
            <div class="item-info">
              <h3 class="item-title">
                {{ event.title }}
              </h3>

              <div class="item-location">
                <i class="fa fa-map-marker"></i>
                {{ eventAddress(event) }}
              </div>

              <div class="item-details">
                <ul>
                  <li>Date and Time <span> {{ getEventFullDateTime(event) }} </span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-alert show v-show="events.length == 0 && !loadingEvents">
      <h6> No events created </h6>
    </b-alert>

    <b-alert show v-show="loadingEvents">
      <h6> Loading events </h6>
    </b-alert>

    <div v-show="events.length > 0">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalEvents"
        :per-page="perPage"
        :limit="3"
        @input="events"
        @change="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import EventService from '../../../services/EventService'
import ApplicationSettingService from '../../../services/ApplicationSettingService'

export default {
  name: 'MyEvents',
  data () {
    return {
      currentPage: 1,
      perPage: 5,
      events: [],
      eventsPerPage: {},
      totalEvents: 0,
      eventStatus: 'published',
      applicationSettings: {
        TICKET_FEE: {
          value: 0
        }
      },
      loadingEvents: true
    }
  },
  created () {
    this.loadEvents()
    this.getApplicationSettings()
  },
  methods: {
    changePage (pageNumber) {
      if (this.eventsPerPage[pageNumber]) {
        this.events = this.eventsPerPage[pageNumber]
      } else {
        this.loadEvents(pageNumber)
      }
    },
    loadEvents (pageNumber) {
      var self = this
      var loader = this.$loading.show()

      EventService.getUserEvents(pageNumber || this.currentPage, this.perPage, this.eventStatus).then(function (response) {
        self.events = response.data
        self.eventsPerPage[pageNumber || self.currentPage] = response.data
        self.totalEvents = parseInt(response.headers['x-total-pagination-count'] || '0')
        self.loadingEvents = false
      }).finally(function () {
        loader.hide()
      })
    },
    getApplicationSettings () {
      var self = this

      ApplicationSettingService.getApplicationSetting().then(function (response) {
        response.data.forEach(function (appSetting, index) {
          self.applicationSettings[appSetting.name] = {
            value: appSetting.value,
            id: appSetting.id
          }
        })
      })
    },
    editEvent (eventId) {
      this.$router.push('/users/events/edit/' + eventId)
    },
    showEvent: function (eventId) {
      this.$router.push({ name: 'showEvent', params: { id: eventId } })
    },
    deleteEvent (eventId) {
      var self = this

      this.$swal({
        title: 'Confirm event deletion?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          EventService.deleteEvent(eventId).then(function (response) {
            self.loadEvents()

            self.$swal({
              title: 'Event deleted!',
              type: 'success'
            })
          }).catch(function (error) {
            var errorMsg = error.response.data.message || error.response.data.error

            if (error) {
              self.$swal({
                title: 'Error deleting Event!',
                text: errorMsg,
                type: 'error'
              })
            }
          })
        }
      })
    },
    duplicateEvent (event) {
      this.$router.push(
        {
          name: 'createEvent',
          params: {
            action: 'new',
            event_to_duplicate: event
          }
        }
      )
    },
    eventAddress (event) {
      return event.venue_name + ', ' + event.address_1 + ' - ' + event.city + ' - ' + event.state
    }
  }
}
</script>
